import React, {useState, useEffect, useCallback} from 'react'
import { injectIntl } from 'react-intl'
import { withRouter} from 'react-router-dom'

import { useDispatch, useSelector } from 'react-redux'
import { refreshToken3 } from '../../actions'


const TokenRefresher =  withRouter(injectIntl(({idleWarning = 0, idleLogout = 0}) => {
    const [ timer , setTimer ] = useState(0)
    const [ timerId , setTimerId ] = useState(null)
    const [ warning, setWarning] = useState(false)

    const dispatch = useDispatch()

    useEffect( () => {
        return () => {
            clearInterval(timerId)
        }
    }, [])

    useEffect ( () => {
        if( ! timerId ) {
            const id = setInterval( () => { 
                dispatch(
                refreshToken3({})
                )}, 1000 * 60 * 60 * 10 ) 
                //)},  1000 ) // <-- testing
 
            setTimerId(id)
        }
        
        return () => {
            
        }
    },[timerId]) 

    return null

}))

export default TokenRefresher